// extracted by mini-css-extract-plugin
export default {"drawer":"MenuDrawer_drawer__JIh6l","drawerHeader":"MenuDrawer_drawerHeader__eqcZ6","drawerOpen":"MenuDrawer_drawerOpen__41ozc"};